export default {
  selectedNumbers: (state) => {
    const numberIndexs = Object.keys(state.selected).filter((k) => {
      return state.selected[k]
    })
    return numberIndexs.map((n) => {
      return parseInt(n)
    })
  },

  isMatch: (state, getters, rootState) => (number) => {
    const founds = []
    const suit = rootState.quiz.quizzes[number]
    for (let key in suit) {
      if (suit[key]) {
        founds.push(suit[key])
      }
    }

    return (founds.length >= state.pair)
  }
}
